export default __webpack_public_path__ + "static/1-81c17a3cc9338f6e78d19b67ec7b56a0.png";